export const NAME = 'paymentMeanDetailsModal';
export const DEFAULT_STATE = {
    visible: false,
    error: false,
    paymentMethods: [],
    isLoading: false,
    isEligibleToKlarna: false,
    isEligibleToFloa10x: false,
    isEligibleToPaypal4x: false,
    isFloaLoaded: true,
    isKlarnaLoaded: true,
    price: 0,
};
export const floa = {
    name: 'FLOA',
    monthlyPayment: 10,
    downPayment: 128.0,
    monthlyPaymentAmount: 150.0,
    creditFeeAmount: 50,
    totalAmount: 1073.0,
    simulationUrl: '',
    schedules: [
        {
            amount: 110,
            date: new Date('2023-09-19T00:00:00.000+00:00'),
            rank: 1,
        },
        {
            amount: 107,
            date: new Date('2023-10-19T00:00:00.000+00:00'),
            rank: 2,
        },
        {
            amount: 107,
            date: new Date('2023-11-18T00:00:00.000+00:00'),
            rank: 3,
        },
        {
            amount: 107,
            date: new Date('2023-12-18T00:00:00.000+00:00'),
            rank: 4,
        },
        {
            amount: 107,
            date: new Date('2024-01-17T00:00:00.000+00:00'),
            rank: 5,
        },
        {
            amount: 107,
            date: new Date('2024-02-16T00:00:00.000+00:00'),
            rank: 6,
        },
        {
            amount: 107,
            date: new Date('2024-03-17T00:00:00.000+00:00'),
            rank: 7,
        },
        {
            amount: 107,
            date: new Date('2024-04-16T00:00:00.000+00:00'),
            rank: 8,
        },
        {
            amount: 107,
            date: new Date('2024-05-16T00:00:00.000+00:00'),
            rank: 9,
        },
        {
            amount: 107,
            date: new Date('2024-06-15T00:00:00.000+00:00'),
            rank: 10,
        },
    ],
};
